import api from "@modules/api/api";
import TradeInType from "@modules/trade/enums/TradeInType";
import { useQuery } from "@tanstack/react-query";
import TradeInDetailsData from "../types/TradeInDetailsData";
import tradeInQueryKeys from "../types/tradeInQueryKeys";

const getTradeInDetailsData = async (
  source: string,
  tradeInType: TradeInType,
  tradeInToken?: string
): Promise<TradeInDetailsData> => {
  return api.get<TradeInDetailsData>(
    `api/trade-in/${source}/trade-in-details/${tradeInType}`,
    {
      headers: {
        Authorization: tradeInToken ? `Bearer ${tradeInToken}` : undefined,
      },
    }
  );
};

export default function useTradeInDetails(
  source: string,
  tradeInType: TradeInType = TradeInType.Standard,
  tradeInToken: string | undefined = undefined,
  enabled = true
) {
  const { data, error, isSuccess, refetch, isStale, isRefetching, isError } =
    useQuery({
      queryKey: tradeInQueryKeys.details(source),
      queryFn: () => getTradeInDetailsData(source, tradeInType, tradeInToken),
      refetchOnMount: "always",
      refetchOnWindowFocus: "always",
      enabled,
    });

  return {
    tradeInData: data,
    isLoading: !error && !data,
    error,
    isSuccess,
    refetch,
    isStale,
    isRefetching,
    isError,
  };
}
